import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import TrendIndicator from './TrendIndicator';
import styles from './KPICard.module.css';

function KPICard({
    title,
    value,
    trend = null,
    trendSuffix = 'vs last period',
    icon: Icon = null,
    color = 'primary',
    sparklineData = null,
    compact = false,
    onClick = null,
}) {
    const sparklineColor = {
        primary: '#4A90E2',
        success: '#50C878',
        warning: '#FFB347',
        danger: '#EF4444',
        secondary: '#7B68EE',
        info: '#60A5FA',
    }[color] || '#4A90E2';

    return (
        <div
            className={`${styles.kpiCard} ${compact ? styles.compact : ''}`}
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
        >
            <div className={styles.header}>
                {Icon && (
                    <div className={`${styles.iconWrapper} ${styles[color]}`}>
                        <Icon size={compact ? 18 : 22} />
                    </div>
                )}
                <div className={styles.content}>
                    <p className={styles.label}>{title}</p>
                    <h3 className={styles.value}>{value}</h3>
                </div>
            </div>

            <div className={styles.footer}>
                {trend !== null && (
                    <TrendIndicator value={trend} suffix={trendSuffix} />
                )}

                {sparklineData && sparklineData.length > 0 && (
                    <div className={styles.sparkline}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={sparklineData}>
                                <defs>
                                    <linearGradient id={`sparkGradient-${color}`} x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor={sparklineColor} stopOpacity={0.4} />
                                        <stop offset="100%" stopColor={sparklineColor} stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <Area
                                    type="monotone"
                                    dataKey="value"
                                    stroke={sparklineColor}
                                    strokeWidth={2}
                                    fill={`url(#sparkGradient-${color})`}
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                )}
            </div>
        </div>
    );
}

export default KPICard;
